import { render, staticRenderFns } from "./labTestActionBar.vue?vue&type=template&id=188c35c8&scoped=true&"
import script from "./labTestActionBar.vue?vue&type=script&lang=js&"
export * from "./labTestActionBar.vue?vue&type=script&lang=js&"
import style0 from "./labTestActionBar.vue?vue&type=style&index=0&id=188c35c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c35c8",
  null
  
)

export default component.exports